<template>
  <div v-if="unit" class="bg-white p-2.5 flex flex-col items-center text-xs">
    <span>{{ $t('main.ads') }}</span>
    <AdController :unit="unit" />
  </div>
</template>
<script>
import { defineComponent, computed } from '@nuxtjs/composition-api';
import AdController from '@/modules/ads/components/AdController';
import { LANG } from '~/constants/config';
export default defineComponent({
  props: {
    index: {
      type: Number,
      required: true,
    },
  },
  components: {
    AdController,
  },
  setup(props) {
    const unit = computed(() => {
      switch (props.index) {
        case 0:
          return 'kategoriTop';
        case 2:
          if (LANG === 'tr') return 'kategoriSponTop';
          else return false;
        case 5:
          return 'kategoriMiddle1';
        case 8:
          if (LANG === 'tr') return 'kategoriSponMiddle';
          else return false;
        case 10:
          return 'kategoriMiddle2';
        case 14:
          if (LANG === 'tr') return 'kategoriSponBottom';
          else return false;
        default:
          return false;
      }
    });
    return { unit };
  },
});
</script>
